/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-expressions */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/jsx-no-duplicate-props */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import Typography from "@material-ui/core/Typography/Typography";

const styles = (theme) => ({
  root: {
    background: "transparent",
    margin: 0,
    display: "inline-flex",
    alignItems: "center",
    textDecoration: "underline",
    textAlign: "center",
    width: "100%",
    padding: "10px 13px",
    [theme.breakpoints.up("sm")]: {
      textDecorationColor: "white",
      paddingLeft: 13,
    },
    "& .MuiTypography-root": {
      fontSize: 16,
      color: `${theme.palette.primary.darkText} !important`,
      "&:hover,&:focus,&:active": {
        color: `${theme.palette.primary.darkText} !important`,
      },
      [theme.breakpoints.up("sm")]: {
        color: `${theme.palette.primary.darkText} !important`,
        "&:hover,&:focus,&:active": {
          color: `${theme.palette.primary.darkText} !important`,
        },
      },
    },
  },
});

class AmountInput extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    classes: PropTypes.object,
    inputProps: PropTypes.string,
    rootProps: PropTypes.string,
    onChangeDebounceWait: PropTypes.number,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    min: PropTypes.number,
    max: PropTypes.number,
    amountLabel: PropTypes.string,
    amount: PropTypes.number,
    autoFocus: PropTypes.bool,
    error: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    readOnly: PropTypes.bool,
    hasValueLabel: PropTypes.bool,
    showAdornment: PropTypes.bool,
    isInToolbar: PropTypes.bool,
  };

  static defaultProps = {
    min: 0,
    max: 999999,
    onChangeDebounceWait: 700,
    hasValueLabel: false,
    showAdornment: false,
  };

  state = {
    value: "",
  };

  componentDidMount() {
    const {
      props: { value },
    } = this;
    this.setState({ value });
  }

  render() {
    const { classes, value } = this.props;

    return (
      <div className={classes.root}>
        <Typography>
          {value || 0}
          &nbsp;
          {t("amountPrice.pieces")}
        </Typography>
      </div>
    );
  }
}

export default withStyles(styles, { name: "AmountInput" })(AmountInput);
